import React from 'react';
import './OrangeButton.scss';

const OrangeButton = ({ children, onClick = null }) => (
    <button className={`orange-button`} onClick={onClick}>
        {children}
    </button>
);

export default OrangeButton;